import React from 'react';
import { pure, bemHelper } from '@dbk/ui-react-utils';
import classnames from 'classnames';
import {
  accordionTitleDefaultProps,
  accordionTitlePropTypes,
  renderComponent,
} from './custom-accordion-common';

import styles from './custom-accordion.css';

const bem = bemHelper(styles, 'custom_accordion', 'item');

const AccordionTitle = ({
  onKeyDown,
  onClick,
  renderTitle,
  renderIcon,
  iconPosition,
  itemKey,
}) => {
  const iconOnLeft = iconPosition === 'left';

  const title = (
    <div key="left" className={bem('title-content')}>
      {renderComponent(renderTitle, 1, { itemKey })}
    </div>
  );

  const iconClassNames = classnames(bem('title-icon'), {
    [bem('title-icon', 'left')]: iconOnLeft,
  });

  const icon = (
    <div key="right" className={iconClassNames}>
      {renderComponent(renderIcon, 1, { itemKey })}
    </div>
  );

  return (
    <div className={bem('title')} onClick={onClick} onKeyDown={onKeyDown} >  
      {iconOnLeft ? [icon, title] : [title, icon]}
    </div>
  );
};

AccordionTitle.defaultProps = accordionTitleDefaultProps;

AccordionTitle.propTypes = accordionTitlePropTypes;

export default pure(AccordionTitle);
